import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {Game} from "../Game";
import {Sound} from "../sound/Sound";
import TrackEntry = PIXI.spine.core.TrackEntry;

export class MaxWinCelebration extends PIXI.Container {
    private _button: ContinueButton;
    private _clickCallback: () => void;
    private _bgOverlay: PIXI.Graphics;
    private _maxWinAnimation: PIXI.spine.Spine;
    private _loopAnim: TrackEntry | undefined;

    constructor() {
        super();
        this.name = "MaxWinCelebration";
        this.init();
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom: number = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }

        if (this._loopAnim) {
            const effectAnimName: string = NolimitApplication.isLandscape ? "wincap/effect_landscape" : "wincap/effect_portrait";
            this._loopAnim = this._maxWinAnimation.state.setAnimation(0, effectAnimName, true);
        }
    }


    public showMXBanner(callback: () => void): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            duration: number = 0.5,
            countUpDuration: number = 7,
            totalWin: number = Game.model.gameData.accumulatedRoundWin,
            effectAnimName: string = NolimitApplication.isLandscape ? "wincap/effect_landscape" : "wincap/effect_portrait";

        this._button.alpha = 0;
        this._button.visible = true;
        this._bgOverlay.alpha = 0;
        this._bgOverlay.visible = true;
        const winCapInTime: number = this._maxWinAnimation.skeleton.data.findAnimation("wincap/wincap_in").duration;
        tl.to([this._bgOverlay, this._maxWinAnimation], {
            duration: duration,
            alpha: 1
        }, 0);
        tl.add(() => {
            this._maxWinAnimation.visible = true;
            this._maxWinAnimation.autoUpdate = true;
            Game.soundPlayer.handleBGMusic(Game.getCurrentGameMode(), false);
            Game.soundPlayer.playSound(Sound.WIN_CAP_START, 1);
            if (!this._loopAnim) {
                this._loopAnim = this._maxWinAnimation.state.setAnimation(0, effectAnimName, true);
            }
            this._clickCallback = callback;
            this._maxWinAnimation.state.setAnimation(0, effectAnimName, true);
            this._maxWinAnimation.state.setAnimation(1, "wincap/wincap_in", false);
        }, "<");

        tl.add([
            () => {
                Game.countUp.getReady(435);
                Game.countUp.stopAt(0);
                Game.countUp.preCalculateScale(0, totalWin);
                Game.countUp.alpha = 1;
                this._maxWinAnimation.state.setAnimation(1, "wincap/wincap_loop", true);
            },
            Game.countUp.getCountAnimation(0, totalWin, countUpDuration),
        ], winCapInTime);

        tl.add([
            () => {
                Game.countUp.stopAt(totalWin);
                Game.keypadPlugin.setWin(totalWin, true, Game.isWinBelowStake());

                Game.soundPlayer.playSound(Sound.WIN_CAP_LOOP, 1, Number.MAX_VALUE);
            },
            gsap.to(Game.countUp, {alpha: 0, duration: 0.1}),
            Game.createTimelineForAnimation(this._maxWinAnimation, 1, "wincap/wincap_end", false)
        ]);

        tl.to(this._button, {
            duration: duration,
            alpha: 1
        });

        tl.add(() => {
            this._button.enable(true);
        });

        return tl;
    }

    private init(): void {
        this.createBGOverlay();

        this._maxWinAnimation = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("bigWins"));
        this._maxWinAnimation.position.set(360, 330);
        this._maxWinAnimation.visible = false;

        this._loopAnim = undefined;

        this._button = new ContinueButton();
        this._button.addClickCallback(() => {
            this.onButtonClick();
        });
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.visible = false;
        this._button.enable(false);

        this.addChild(this._maxWinAnimation, this._button);

        this.onResize();
    }

    private onButtonClick(): void {
        const tl: gsap.core.Timeline = gsap.timeline(),
            duration: number = 0.5;

        this._button.enable(false);

        Game.backgroundElements.setMode(Game.model.data.nextMode);

        tl.to([this._button, this._bgOverlay, this._maxWinAnimation, Game.countUp], {
            duration: duration,
            alpha: 0
        }, 0);
        tl.add(Game.scatterInventory.showSMeter(), 0);

        tl.add(() => {
            this._button.visible = false;
            this._bgOverlay.visible = false;
            Game.countUp.visible = false;
            this._maxWinAnimation.visible = false;
            this._maxWinAnimation.state.clearTracks();
            this._maxWinAnimation.skeleton.setToSetupPose();
            this._maxWinAnimation.skeleton.setSlotsToSetupPose();

            this._maxWinAnimation.alpha = 1;
            Game.countUp.alpha = 1;

            Game.soundPlayer.stopSound(Sound.WIN_CAP_START);
            Game.soundPlayer.stopSound(Sound.WIN_CAP_LOOP);
            Game.soundPlayer.handleBGMusic(Game.getCurrentGameMode(), true);

            this._clickCallback();
        });

        this._loopAnim = undefined;
    }

    private createBGOverlay(): void {
        this._bgOverlay = new PIXI.Graphics().beginFill(0x000000, 0.7).drawRect(-480, -480, 1680, 1680).endFill();
        this._bgOverlay.name = "dark-overlay";
        this._bgOverlay.visible = false;

        this.addChild(this._bgOverlay);
    }
}
